import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=0b8110e7&"
import script from "./AppLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppLayout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports